/* Packages */
import React from 'react';
import { hydrate } from 'react-dom';

/* Components */
import ProductSearch from './components/ProductSearch';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productSearchNodes = Array.from(document.querySelectorAll('.product-search'));
[...productSearchNodes].forEach((node) => hydrate(<ProductSearch {...parseDataToProps(node.dataset)} />, node));
